/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ class $a5fd07fa01589658$var$Game {
    /**
   * Creates a new game instance.
   *
   * @param {number[][]} initialState
   * The initial state of the board.
   * @default
   * [[0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0]]
   *
   * If passed, the board will be initialized with the provided
   * initial state.
   */ constructor(initialState){
        this.size = 4;
        this.score = 0;
        this.status = "idle";
        this.board = initialState ? initialState.map((row)=>[
                ...row
            ]) : Array.from({
            length: this.size
        }, ()=>Array(this.size).fill(0));
    }
    createBoard() {
        return Array.from({
            length: this.size
        }, ()=>Array(this.size).fill(0));
    }
    moveLeft() {
        const moved = this.move((row)=>row, (row)=>row.reverse(), (row)=>row.reverse());
        if (moved) this.afterMove();
    }
    moveRight() {
        const moved = this.move((row)=>row.reverse(), (row)=>row.reverse(), (row)=>row);
        if (moved) this.afterMove();
    }
    moveUp() {
        const moved = this.moveColumns((c)=>c, (c)=>c.reverse(), (c)=>c.reverse());
        if (moved) this.afterMove();
    }
    moveDown() {
        const moved = this.moveColumns((c)=>c.reverse(), (c)=>c.reverse(), (c)=>c);
        if (moved) this.afterMove();
    }
    /**
   * @returns {number}
   */ getScore() {
        return this.score;
    }
    /**
   * @returns {number[][]}
   */ getState() {
        return this.board.map((row)=>[
                ...row
            ]);
    }
    /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ getStatus() {
        return this.status;
    }
    /**
   * Starts the game.
   */ start() {
        this.score = 0;
        this.status = "playing";
        this.board = this.createBoard();
        this.addRandomTile();
        this.addRandomTile();
    }
    /**
   * Resets the game.
   */ restart() {
        this.start();
    }
    addRandomTile() {
        const empty = [];
        for(let a = 0; a < this.size; a++){
            for(let b = 0; b < this.size; b++)if (this.board[a][b] === 0) empty.push([
                a,
                b
            ]);
        }
        if (empty.length === 0) return;
        const [r, c] = empty[Math.floor(Math.random() * empty.length)];
        this.board[r][c] = Math.random() < 0.9 ? 2 : 4;
    }
    move(transformIn, transformOut, restore) {
        let moved = false;
        for(let r = 0; r < this.size; r++){
            let row = [
                ...this.board[r]
            ];
            row = transformIn(row);
            const merged = [];
            const compact = row.filter((v)=>v !== 0);
            for(let i = 0; i < compact.length - 1; i++)if (compact[i] === compact[i + 1]) {
                compact[i] *= 2;
                this.score += compact[i];
                compact[i + 1] = 0;
                merged.push(i);
            }
            const finalRow = compact.filter((v)=>v !== 0);
            while(finalRow.length < this.size)finalRow.push(0);
            const restored = restore(transformOut(finalRow));
            if (restored.toString() !== this.board[r].toString()) moved = true;
            this.board[r] = restored;
        }
        return moved;
    }
    moveColumns(transformIn, transformOut, restore) {
        let moved = false;
        for(let c = 0; c < this.size; c++){
            let col = [];
            for(let r = 0; r < this.size; r++){
                col.push(this.board[r][c]);
                col = transformIn(col);
            }
            const compact = col.filter((v)=>v !== 0);
            for(let i = 0; i < compact.length - 1; i++)if (compact[i] === compact[i + 1]) {
                compact[i] *= 2;
                this.score += compact[i];
                compact[i + 1] = 0;
            }
            const finalCol = compact.filter((v)=>v !== 0);
            while(finalCol.length < this.size)finalCol.push(0);
            const restored = restore(transformOut(finalCol));
            for(let r = 0; r < this.size; r++){
                if (this.board[r][c] !== restored[r]) moved = true;
                this.board[r][c] = restored[r];
            }
        }
        return moved;
    }
    afterMove() {
        this.addRandomTile();
        this.checkStatus();
    }
    checkStatus() {
        if (this.board.flat().includes(2048)) {
            this.status = "win";
            return;
        }
        if (this.board.flat().includes(0)) {
            this.status = "playing";
            return;
        }
        for(let r = 0; r < this.size; r++)for(let c = 0; c < this.size; c++){
            const val = this.board[r][c];
            if (r < this.size - 1 && val === this.board[r + 1][c] || c < this.size - 1 && val === this.board[r][c + 1]) {
                this.status = "playing";
                return;
            }
        }
        this.status = "lose";
    }
}
var $a5fd07fa01589658$export$2e2bcd8739ae039 = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new (0, $a5fd07fa01589658$export$2e2bcd8739ae039)();
const $09e991522ca7e64e$var$startButton = document.querySelector(".button");
const $09e991522ca7e64e$var$scoreElement = document.querySelector(".game-score");
const $09e991522ca7e64e$var$cells = document.querySelectorAll(".field-cell");
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message-start");
const $09e991522ca7e64e$var$messageWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$messageLose = document.querySelector(".message-lose");
function $09e991522ca7e64e$var$renderBoard() {
    const state = $09e991522ca7e64e$var$game.getState();
    let index = 0;
    for(let r = 0; r < 4; r++)for(let c = 0; c < 4; c++){
        const value = state[r][c];
        const cell = $09e991522ca7e64e$var$cells[index];
        index++;
        cell.textContent = value === 0 ? "" : value;
        cell.className = "field-cell";
        if (value !== 0) cell.classList.add(`field-cell--${value}`);
    }
    $09e991522ca7e64e$var$scoreElement.textContent = $09e991522ca7e64e$var$game.getScore();
    // повідомлення
    $09e991522ca7e64e$var$messageStart.classList.add("hidden");
    $09e991522ca7e64e$var$messageWin.classList.add("hidden");
    $09e991522ca7e64e$var$messageLose.classList.add("hidden");
    if ($09e991522ca7e64e$var$game.getStatus() === "win") $09e991522ca7e64e$var$messageWin.classList.remove("hidden");
    else if ($09e991522ca7e64e$var$game.getStatus() === "lose") $09e991522ca7e64e$var$messageLose.classList.remove("hidden");
}
function $09e991522ca7e64e$var$handleMove(direction) {
    if ($09e991522ca7e64e$var$game.getStatus() !== "playing") return;
    switch(direction){
        case "ArrowLeft":
            $09e991522ca7e64e$var$game.moveLeft();
            break;
        case "ArrowRight":
            $09e991522ca7e64e$var$game.moveRight();
            break;
        case "ArrowUp":
            $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowDown":
            $09e991522ca7e64e$var$game.moveDown();
            break;
        default:
            return;
    }
    $09e991522ca7e64e$var$renderBoard();
    if ($09e991522ca7e64e$var$startButton.classList.contains("start")) {
        $09e991522ca7e64e$var$startButton.classList.remove("start");
        $09e991522ca7e64e$var$startButton.classList.add("restart");
        $09e991522ca7e64e$var$startButton.textContent = "Restart";
    }
}
$09e991522ca7e64e$var$startButton.addEventListener("click", ()=>{
    $09e991522ca7e64e$var$game.start();
    $09e991522ca7e64e$var$renderBoard();
    $09e991522ca7e64e$var$startButton.classList.remove("start");
    $09e991522ca7e64e$var$startButton.classList.add("restart");
    $09e991522ca7e64e$var$startButton.textContent = "Restart";
});
document.addEventListener("keydown", (e)=>$09e991522ca7e64e$var$handleMove(e.key));
$09e991522ca7e64e$var$renderBoard();


//# sourceMappingURL=index.4b771011.js.map
